<div class="card step-card flex flex-column">
  <form [formGroup]="templateForm" *ngIf="templateForm">
    <div class="grid">
      <div class="col-12 md:col-12 lg:col-6 xl:col-4">
        <div class="form-field col-12">
          <label for="name">{{'attribute.name' | transloco}} (*)</label>
        </div>
        <div class="col-12">
          <input pInputText id="name" type="text" formControlName="name" class="w-full">
        </div>
        <app-validation-errors [control]="templateForm.get('name')"></app-validation-errors>
      </div>
      <div class="col-12 md:col-12 lg:col-6 xl:col-4">
        <div class="form-field col-12">
          <label for="description">{{'attribute.description' | transloco}}</label>
        </div>
        <div class="col-12">
          <input pInputText id="description" type="text" formControlName="description" class="w-full">
        </div>
      </div>
      <div class="col-12 md:col-12 lg:col-6 xl:col-4">
        <div class="form-field col-12">
          <label for="type">{{'model.type' | transloco}} (*)</label><br>
        </div>
        <div class="col-12">
          <p-dropdown
            [placeholder]="'select.type' | transloco"
            [options]="types"
            [filter]="true"
            (onChange)="onTypeChange($event)"
            styleClass="w-full"
            id="type"
            formControlName="type"
          ></p-dropdown>
        </div>
      </div>
      <div class="col-12 md:col-12 lg:col-6 xl:col-4">
        <div class="form-field col-12">
          <label for="tenant">{{'model.tenant' | transloco}} (*)</label>
        </div>
        <div class="col-12">
          <p-dropdown
            [placeholder]="'select.tenant' | transloco"
            [options]="tenants"
            [filter]="true"
            (onChange)="onTenantChange($event)"
            styleClass="w-full"
            id="tenant"
            optionLabel="name"
            formControlName="tenant"
          ></p-dropdown>
        </div>
      </div>
      <div class="col-12 md:col-12 lg:col-6 xl:col-4">
        <div class="form-field col-12">
          <label for="category">{{'model.category' | transloco}}
            <span *ngIf="deviceTypeSelected">&nbsp;(*)</span>
          </label><br>
        </div>
        <div class="col-12">
          <p-dropdown
            [placeholder]="'select.category' | transloco"
            [options]="deviceCategories"
            [filter]="true"
            styleClass="w-full"
            id="category"
            optionLabel="name"
            formControlName="deviceCategory"
          ></p-dropdown>
        </div>
      </div>
    </div>
  </form>

  <div class="mt-auto">
    <div class="flex flex-column sm:flex-row justify-content-between">
      <div class="flex justify-content-between sm:justify-content-start sm:flex-order-1">
        <button
          [label]="'common.next' | transloco"
          [disabled]="!isValid()"
          (click)="onNextStep()"
          pButton
          pRipple
          class="flex-1"
          icon="pi pi-angle-right"
          iconPos="right"
        ></button>
      </div>
      <button
        [label]="'common.cancel' | transloco"
        (click)="onCancel()"
        pButton
        pRipple
        class="p-button-danger mt-2 sm:mt-0 sm:flex-order-0"
      ></button>
    </div>
  </div>
</div>
